import { useEffect, useState } from 'react'
import { catalan_calendar } from '../../utils/editDatePicker'
import { LocalStorage } from '../../services/localStorage/LocalStorage.services'

import DatePicker from "react-multi-date-picker"
import Modal from '../../components/Modal/Modal'
import Select from 'react-select'

import getProfessionals from '../../services/professionals/getAllProfessionals'
import getActionById from '../../services/tasks/getTaskById'
import postAction from '../../services/actions/postAction'
import putAction from '../../services/actions/putAction'

import styles from './NewAction.module.css'

const NewAction = (props) => {
    
    const [ newAction, setNewAction ] = useState({})
    const [ professionals, setProfessionals ] = useState([])
    const [ professionalsSelected, setProfessionalsSelected ] = useState({})
    const [ active, setActive ] = useState(true)
    const [ error, setError ] = useState("")
    const [ update, setUpdate ] = useState(false)
    const [ disable, setDisable ] = useState(true)
    const [ valueInitialData, setValuesInitialData ] = useState(null)

    useEffect(() => {
        getProfessionals()
        .then(professionals => {
            setProfessionals(professionals)
            const professionalSelected = professionals.filter(element => element._id === LocalStorage.getItem("id"))
            setProfessionalsSelected(professionalSelected.map(element => ({
                value: element._id,
                label: `${element.professionalName} ${element.professionalLastName1} ${element.professionalLastName2}`
            })))
        })
        // if (props.action !== undefined) {
        //     getActionById(props.action._id)
        //     .then(action => {
        //         setNewAction(action)
        //         setActive(action.actionActive)
        //         if (action.actionDoDate) {
        //             let dateInitial = new Date(action.actionDoDate)
        //             setValuesInitialData(dateInitial)
        //         }
        //     })
        // }
    },[update])

    const handleSubmit = (event) => {
        event.preventDefault()
        let form = event.target
        let formData = new FormData(form)
        formData.append('actionCompanyId', LocalStorage.getItem("professionalCompany"))
        formData.append('actionServeiId', LocalStorage.getItem("professionalServei"))
        formData.append('actionTaskId', props.id)
        let formJson = Object.fromEntries(formData.entries())
        // console.log(formJson)
        // if (props.actionId !== undefined) {
        //     if (valueInitialData !== null) {
        //         let dateUnixInitial = new Date(valueInitialData).toISOString()
        //         formJson.actionDoDate = dateUnixInitial
        //     }
        //     console.log(formJson, 1)
        //     putAction(formJson, dadesRebudes.id) 
        //     .then(newAction => {
        //         setNewAction(newAction)
        //     })
        // } else {
            let dateUnixInitial = new Date(valueInitialData.unix * 1000).toISOString()
            formJson.actionDoDate = dateUnixInitial
            postAction(formJson) 
            .then(newAction => {
                setNewAction(newAction)
            })
        // }
        setDisable(false)
        setTimeout(() => {
            setDisable(true)
            setNewAction({})
            props.setUpdate(!props.update)
            setUpdate(!update)
        },3000)
    }

    const handleChange = (event) => {
        if (event.target.id === "actionActive") {
            setActive(event.target.checked)
        } else {
            setNewAction(event.target.value)
        }
    }

    const handleChangeProfessionals = (selectedOptions) => {
        setProfessionalsSelected(selectedOptions)
    }

    const professionalsOptions = professionals.map(element => ({
        value: element._id,
        label: `${element.professionalName} ${element.professionalLastName1} ${element.professionalLastName2}` 
    }))

    return (
        <div className={styles.container}>
            {/* <h2>{dadesRebudes.id ? "Editar acció" : "Afegir acció"}</h2> */}
            <h2>Afegir acció</h2>
            <div className={`${styles.modal} ${disable && styles.disable}`}>
            {/* <Modal error={error} id={dadesRebudes.id} text={dadesRebudes.id ? "Acció modificada correctament" : "Acció creada correctament"}></Modal> */}
            <Modal error={error} text="Acció creada correctament"></Modal>
            </div>
            <form onSubmit={handleSubmit}>
                <label for="actionDescription">Acció</label>
                <textarea rows={15} name="actionDescription" onChange={handleChange} value={newAction.actionDescription} required/>
                <label>Data</label>
                <DatePicker   
                    style={{
                        width: "100%",
                        height: "40px",
                        boxSizing: "border-box",
                        padding: "0.5em",
                        backgroundColor: "aliceblue",
                        borderRadius: ".3rem",
                        border: "none",
                    }}
                    containerStyle={{
                        width: "100%"
                    }}
                    required
                    calendarPosition="bottom-center" 
                    locale={catalan_calendar}
                    displayWeekNumbers="enable"
                    numberOfMonths={1}
                    weekStartDayIndex={1}
                    value={valueInitialData} 
                    format="DD/MM/YYYY"
                    onChange={setValuesInitialData} 
                />
                <label for="actionProfessionalId">Realitzat per</label>
                <Select
                    className={styles.select}
                    name="actionProfessionalId"
                    value={professionalsSelected}
                    onChange={handleChangeProfessionals}
                    options={professionalsOptions}
                    placeholder="- Selecciona -"
                />
                <div className={styles.btn_container}>
                    <button className={ styles.btn_add} type='submit'><span>Crear</span></button>
                </div>
            </form>
        </div>
    )
} 

export default NewAction